var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8769 17H3.64258V5.47136L9.25786 1L14.8769 5.47136V17Z",
    stroke: "#1B224C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.0625 17.0001V12.6592H11.4556V17.0001",
    stroke: "#1B224C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.25779 8.50436C10.1283 8.50436 10.8339 7.79869 10.8339 6.9282C10.8339 6.05772 10.1283 5.35205 9.25779 5.35205C8.38731 5.35205 7.68164 6.05772 7.68164 6.9282C7.68164 7.79869 8.38731 8.50436 9.25779 8.50436Z",
    stroke: "#1B224C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.64183 17H1V8.72803H3.64183",
    stroke: "#1B224C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.877 8.72803H17.7759V17H14.877",
    stroke: "#1B224C",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/houseIcon.caa3e2409043743abd54212727a62ec0.svg";
export { ForwardRef as ReactComponent };